<template>
  <button @click.prevent="doClick">
    <block-spinner :active="isLoading" size="5" color="text-white" class="absolute"></block-spinner>
    <p :class="[{'opacity-0':isLoading}]">{{ title }}</p>
  </button>
</template>

<script>
	// As used in the job alert panel on the search page, and also on the users' home page showing their saved alerts.
	// Avoid styling in this component, as they can look different.

	export default {
    name: 'SavedSearchAlertBtn',

    props: {
    	id: {
    		type: String
    	},
      title: {
        type: String,
        default: 'Edit'
      }
    },

    data() {
      return {
        isLoading: false
      }
    },

    mounted() {

    },

    methods: {
      doClick() {
        this.isLoading = true;
        this.emitter.emit("openModal", { name: 'EditSavedSearchAlert', 'job_alert_id': this.id });
        setTimeout(() => {
          this.isLoading = false;
        }, 600);
      }
    }
  };
</script>
